export default __webpack_public_path__ + "static/media/EM0999.34I-41719_-25014_0.93742de1.jpg";